// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"686":"f26a87bc","721":"d95ee6c6"}[chunkId] + ".chunk.css";
};